import $http from "../services/AxiosInstance";
import { IAgenciesOption } from '../types/agencies.type';

class AgenciesDataProviderRepository {
  static async getAllAgencies(): Promise<IAgenciesOption[]> {
    try {
      const response = await $http.get(`certificate/agencies`);
      return response.data;
    } catch (errors: any) {
      return errors;
    }
  }
}

export default AgenciesDataProviderRepository;
